var _path, _g, _path2, _path3, _path4, _path5, _g2, _g3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNoPostsIllustration(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 208,
    height: 197,
    viewBox: "0 0 208 197",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Group 2725"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 2616"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Mask group"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_5329_2207",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 193,
    height: 197
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector 5104",
    d: "M71 196.5L39 176.5L0 22.5L159.5 0L192.5 183L71 196.5Z",
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_5329_2207)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector 5102",
    filter: "url(#filter0_d_5329_2207)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M142.016 17.3076L19.5074 32.565C15.4588 33.0692 12.6976 36.915 13.5141 40.9123L44.202 191.145C44.9343 194.731 48.3044 197.147 51.9349 196.69L173.07 181.436C177.09 180.929 179.842 177.127 179.066 173.15L149.751 22.9133C149.047 19.3022 145.667 16.8528 142.016 17.3076Z",
    fill: "url(#paint0_linear_5329_2207)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.016 17.3076L19.5074 32.565C15.4588 33.0692 12.6976 36.915 13.5141 40.9123L44.202 191.145C44.9343 194.731 48.3044 197.147 51.9349 196.69L173.07 181.436C177.09 180.929 179.842 177.127 179.066 173.15L149.751 22.9133C149.047 19.3022 145.667 16.8528 142.016 17.3076Z",
    fill: "url(#paint1_linear_5329_2207)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.016 17.3076L19.5074 32.565C15.4588 33.0692 12.6976 36.915 13.5141 40.9123L44.202 191.145C44.9343 194.731 48.3044 197.147 51.9349 196.69L173.07 181.436C177.09 180.929 179.842 177.127 179.066 173.15L149.751 22.9133C149.047 19.3022 145.667 16.8528 142.016 17.3076Z",
    stroke: "white"
  }))))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Vector 5103",
    d: "M67.5 194L41.5 178L57.4875 174.909C61.4424 174.145 65.225 176.868 65.7552 180.861L67.5 194Z",
    fill: "#C7D2F6",
    stroke: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Vector 5107",
    d: "M38 60.5L122 49.5",
    stroke: "url(#paint2_linear_5329_2207)",
    strokeOpacity: 0.8,
    strokeWidth: 8,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Vector 5108",
    d: "M44 85.5L139.5 72.5",
    stroke: "url(#paint3_linear_5329_2207)",
    strokeOpacity: 0.8,
    strokeWidth: 8,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Vector 5110",
    d: "M50 107.5L126 97.5",
    stroke: "url(#paint4_linear_5329_2207)",
    strokeOpacity: 0.8,
    strokeWidth: 8,
    strokeLinecap: "round"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group 2617"
  }, /*#__PURE__*/React.createElement("foreignObject", {
    x: 128,
    y: 93,
    width: 80,
    height: 82
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(2px)",
      clipPath: "url(#bgblur_0_5329_2207_clip_path)",
      height: "100%",
      width: "100%"
    }
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Ellipse 247",
    filter: "url(#filter1_d_5329_2207)",
    "data-figma-bg-blur-radius": 4
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 168,
    cy: 133,
    r: 36,
    fill: "url(#paint5_linear_5329_2207)",
    fillOpacity: 0.71,
    shapeRendering: "crispEdges"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group 2434"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M179.16 116.174C180.725 114.609 183.262 114.609 184.826 116.174C186.391 117.738 186.391 120.275 184.826 121.84L173.666 133L184.826 144.16C186.391 145.725 186.391 148.262 184.826 149.826C183.262 151.391 180.725 151.391 179.16 149.826L168 138.666L156.84 149.826C155.275 151.391 152.738 151.391 151.174 149.826C149.609 148.262 149.609 145.725 151.174 144.16L162.334 133L151.174 121.84C149.609 120.275 149.609 117.738 151.174 116.174C152.738 114.609 155.275 114.609 156.84 116.174L168 127.334L179.16 116.174Z",
    fill: "#4C95FF"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_5329_2207",
    x: 8.87061,
    y: 12.7534,
    width: 174.827,
    height: 188.492,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5329_2207"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_5329_2207",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_5329_2207",
    x: 128,
    y: 93,
    width: 80,
    height: 82,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_5329_2207"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_5329_2207",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bgblur_0_5329_2207_clip_path",
    transform: "translate(-128 -93)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 168,
    cy: 133,
    r: 36
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5329_2207",
    x1: 96.25,
    y1: 16.5,
    x2: 96.25,
    y2: 197.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DDEBF6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E2E9FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_5329_2207",
    x1: 96.25,
    y1: 16.5,
    x2: 96.25,
    y2: 197.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DDEBF6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E2E9FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_5329_2207",
    x1: 146,
    y1: 48,
    x2: 38.5,
    y2: 57.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.8
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_5329_2207",
    x1: 150,
    y1: 72.5,
    x2: 44,
    y2: 85.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.8
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_5329_2207",
    x1: 140,
    y1: 90,
    x2: 46,
    y2: 102.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_5329_2207",
    x1: 132,
    y1: 127,
    x2: 208.5,
    y2: 150.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFFBF4"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoPostsIllustration);
export default __webpack_public_path__ + "static/media/noPostsIllustration.d1e6811f4dbf19fc16a5451d21f1df2f.svg";
export { ForwardRef as ReactComponent };